import React from 'react';

import ApplicationContext from '../../ApplicationContext';

const useQuestion = (question) => {
    const { updateAnswer } = React.useContext(ApplicationContext);

    const [chosenVal, setChosenVal] = React.useState(question?.chosenOptions ? question.chosenOptions : []);
    const [answerText, setAnswerText] = React.useState(question?.answerText ? question.answerText : '');

    const [isInvalid, setIsInvalid] = React.useState(false);
    const [isSaving, setIsSaving] = React.useState(false);

    const handleCheckbox = (e) => {
        const toggledId = parseInt(e.target.value);
        const previousIndex = chosenVal.indexOf(toggledId);

        var newChosenVals = [];
        if (previousIndex < 0) {
            newChosenVals = [...chosenVal, toggledId];
        } else {
            newChosenVals = chosenVal.filter((_a, i) => {
                return i !== previousIndex;
            });
        }

        setChosenVal(newChosenVals);
    };

    const handleTextChange = (e) => {
        if (isInvalid) setIsInvalid(false);
        console.log(`Changed value is ${e.target.value}`);

        setAnswerText(e.target.value);

        if (question.responseRegexes.length > 0 && !question.responseRegexes.every((entry) => RegExp(entry.rgx).test(e.target.value))) {
            setIsInvalid(true);
            return;
        }

        console.log('Passed validation');
    };

    const handleTextBlur = async (newVal) => {
        setIsSaving(true);
        await updateAnswer(newVal, question);
        setIsSaving(false);
    };

    //#TODO TechDebt - The components that leverage this Hook have been so far only implemented in Read Only state. Further functionality will need to be implemented after the TSB project.
    const handleOptionChange = (newVal) => {};

    return {
        isSaving,
        isInvalid,
        chosenVal,
        handleOptionChange,
        answerText,
        handleTextChange,
        handleTextBlur,
        handleCheckbox,
    };
};

export default useQuestion;
